<page-headline
    [linkTitle]="'Leads & Partners Home'"
    [module]="'leads-partners'"
    [moduleIcon]="'fa-handshake'"
    [moduleLink]="'leads-partners'"
    [pageTitle]="'Leads & Partners Upgrade'"
>
</page-headline>
<module-upgrade
    [headline]="headline"
    [shortOverview]="shortOverview"
    [selligPointHeader]="selligPointHeader"
    [logoPlaceholder]="logoPlaceholder"
    [moduleShortDescription]="moduleShortDescription"
    [backgroundColor]="backgroundColor"
>
</module-upgrade>
